import { Text } from '@fozito/common-ui';
import { Avatar } from 'antd';
import homeApis from 'modules/dashboard/services/apis';
import cashierService from 'modules/POS/services';
import shopService from 'modules/shop/services';
import { verifyPasscodeWithConfig } from 'modules/shop/widgets/ModalCheckPassCode';
import { forwardRef, useImperativeHandle, useMemo } from 'react';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import toast from 'utils/toast';
import clock_in_icon from './clock-in.png';

type Props = {
  value?: string;
  onChange?: (value: string) => void;
};
type StaffHandlerRef = {
  requestClockIn: () => void;
};
const StaffHandler = forwardRef<StaffHandlerRef, Props>(({ value, onChange = () => undefined }, ref) => {
  const dispatch = useAppDispatch();
  const staffs = shopService.selectors.staffs();
  const activeStaff = useMemo(
    () => staffs.find((staff) => staff.id === value),
    [value, staffs]
  );

  const onClockIn = () => {
    verifyPasscodeWithConfig(async (staff) => {
      try {
        const res = await homeApis.staff.checkIn({ passcode: staff.passCode }, staff.id);
        if (res.data.data) {
          onChange(staff.id);
          dispatch(cashierService.actions.saveStaffCashier(staff));
        } else {
          toast.error(res.data?.message || 'Failed to clock in');
        }
      } catch (error: any) {
        toast.error(error?.response?.data?.message || error?.message || 'Failed to clock in');
      }
    }, { title: 'Clock In' });
  };

  const onClockOut = () => {
    verifyPasscodeWithConfig(async (staff) => {
      try {
        const res = await homeApis.staff.checkOut({ passcode: staff.passCode }, staff.id);
        if (res.data.data) {
          onChange('');
          dispatch(cashierService.actions.saveStaffCashier(null));
        } else {
          toast.error(res.data?.message || 'Failed to clock out');
        }
      } catch (error: any) {
        toast.error(error?.response?.data?.message || error?.message || 'Failed to clock out');
      }
    }, { title: 'Clock out' });
  };

  useImperativeHandle(ref, () => ({
    requestClockIn: onClockIn,
  }));

  if (!activeStaff) return (
    <ContainerButton type='button' onClick={onClockIn}>
      <img src={clock_in_icon} alt="clock_in_icon" style={{ height: 42, width: 'auto' }} />
      <Text content_content_3_16_semibold>Clock In</Text>
    </ContainerButton>
  );
  return (
    <AvatarContainer
      onClick={onClockOut}
      size={94}
      src={
        activeStaff.avatar || ''
      }
      style={{ fontSize: 40, fontWeight: '600', color: '#1D2129', background: '#E5E6EB' }}
      alt={activeStaff.firstName}
    >{activeStaff.firstName?.[0] || 'A'}</AvatarContainer>
  );
});
StaffHandler.displayName = 'StaffHandler';
export default StaffHandler;
const AvatarContainer = styled(Avatar)`
&:hover,
&:active {
  cursor: pointer;
  opacity: 0.8;
  transform: scale(1.05);
  transition: all 0.1s;
}

&:disabled {
  opacity: 0.7;
  &:hover,
  &:active {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
    transition: none;
  }
}
`;

const ContainerButton = styled.button`
display: flex;
padding: 4px 24px;
flex-direction: column;
justify-content: center;
align-items: center;
gap: 4px;
border-radius: 4px;
background: #FFF;
box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.40), 0px 4px 8px -3px rgba(45, 35, 66, 0.30), 0px -3px 0px 0px #D6D6E7 inset;
&:hover,
&:active {
  opacity: 0.8;
  transform: scale(1.05);
  transition: all 0.1s;
}

&:disabled {
  opacity: 0.7;
  &:hover,
  &:active {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
    transition: none;
  }
}
`;